$(function () {

  var actions_buttons = $('#call-seller')

  function animateScrollAnchor(e) {
    e.preventDefault();

    $('html, body').animate({
      'scrollTop': $('#seller-anchor').offset().top
    }, 1000);
  }

  function checkDeviceWidth() {
    window.innerWidth >= 991 ?
      actions_buttons.bind('click', animateScrollAnchor) :
      actions_buttons.unbind('click', animateScrollAnchor)
  }

  checkDeviceWidth();
  $(window).resize(checkDeviceWidth);
});


// WEBPACK FOOTER //
// ./app/webpacker/src/js/call_seller_button_actions.js